import React from "react";
import { Link } from "react-router-dom";
import { CONTACT } from "../data/contactInfo";
import { WhatsAppIcon } from "./WhatsAppButton";
import "../styles/FloatingActions.css";

const FloatingActions = () => (
  <div className="floating-actions" aria-label="Quick booking">
    <Link to={{ pathname: "/contact", search: "?type=wedding&form=open" }} className="floating-btn floating-btn-book">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
      <span>Book Now</span>
    </Link>
    <a
      href={CONTACT.whatsapp}
      className="floating-btn floating-btn-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <WhatsAppIcon size={26} />
    </a>
  </div>
);

export default FloatingActions;
